import { myTrainingCourseListRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.Student];

const myTrainingCourseListRouteMetadata: IRouteMetadataObj<
  typeof myTrainingCourseListRoutesObj
> = {
  list: {
    title: "myTrainingCourseList.index.title",
    description: "myTrainingCourseList.index.description",
    lazy: () => import("@/pages/studentPages/trainingCourseList/table/page"),
    mode: "index",
    type: "main",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    permission,
  },
  view: {
    title: "myTrainingCourseList.view.title",
    description: "myTrainingCourseList.view.description",
    lazy: () => import("@/pages/studentPages/trainingCourseList/view/page"),
    mode: "edit",
    type: "inner",
    icon: "GraduationCapLine",
    breadcrumbs: [],
    isPageFullMode: true,
    permission,
  },
};

export const myTrainingCourseListRoutes = createRoute<
  typeof myTrainingCourseListRoutesObj
>(myTrainingCourseListRoutesObj, myTrainingCourseListRouteMetadata);
